import { render, staticRenderFns } from "./PeriodRiskSpread.vue?vue&type=template&id=30d5ad9b&scoped=true&"
import script from "./PeriodRiskSpread.vue?vue&type=script&lang=js&"
export * from "./PeriodRiskSpread.vue?vue&type=script&lang=js&"
import style0 from "./PeriodRiskSpread.vue?vue&type=style&index=0&id=30d5ad9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d5ad9b",
  null
  
)

export default component.exports